import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded'
import HelpRoundedIcon from '@mui/icons-material/HelpRounded'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import {Button, Stack, StackProps, styled} from '@mui/material'

export const TrueIcon = styled(CheckCircleIcon)(({theme}) => ({
  color: theme.palette.success.main,
}))

export const FalseIcon = styled(CancelRoundedIcon)(({theme}) => ({
  color: theme.palette.error.main,
}))

export const ActionButtonContainer = styled(Stack)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}))

export const ActionButton = styled(Button)(() => ({
  padding: '0.25rem',
  height: '1.5rem',
}))

export const UnlinkButton = styled(Button)(({theme}) => ({
  padding: '0.25rem 0.5rem',
  height: '1.5rem',
  backgroundColor: theme.palette.error.main,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}))

export const CountryCellContainer = styled(Stack)(() => ({
  height: '100%',
  display: 'flex',
  gap: '0.5rem',
  paddingRight: '1rem',
  alignItems: 'center',
  flexDirection: 'row',
}))

export const CompanyWithFlagWrapper = styled(Stack)(() => ({
  height: '100%',
  justifyContent: 'flex-start',
  gap: '0.5rem',
  flexDirection: 'row',
  overflow: 'hidden',
  alignItems: 'center',
}))

export const CompanyLabelWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
}))

export const GoodScoreIcon = styled(CheckCircleRoundedIcon)(({theme}) => ({
  color: theme.palette.success.main,
}))

export const WarningScoreIcon = styled(WarningRoundedIcon)(({theme}) => ({
  color: theme.palette.warning.main,
}))

export const BadScoreIcon = styled(ErrorRoundedIcon)(({theme}) => ({
  color: theme.palette.error.main,
}))

export const UnknownScoreIcon = styled(HelpRoundedIcon)(({theme}) => ({
  color: theme.palette.grey['100'],
}))

export const StatusCellOuterWrapper = styled(Stack)(() => ({
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 4px',
}))

export const StatusCellInnerWrapper = styled(Stack, {shouldForwardProp: prop => prop !== 'color' && prop !== 'border'})<
  StackProps & {color: string; border: string}
>(({color, border}) => ({
  borderRadius: '1rem',
  height: '1.25rem',
  borderColor: border,
  borderStyle: 'solid',
  borderWidth: 1,
  backgroundColor: color,
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  flexDirection: 'row',
  gap: 8,
  paddingLeft: 6,
}))

export const ClickableCell = styled(Stack)(({theme}) => ({
  color: theme.palette.primary.light,
  textDecoration: 'underline',
  cursor: 'pointer',
}))
